/* ─────────────────────────────────────────────────────────────
   Panel desplegable de cabecera — Unfeigned
   ───────────────────────────────────────────────────────────── */
(function () {

  /* ── Abrir y cerrar subcategorias con + / − ── */
  document.addEventListener('click', function (event) {
    var boton = event.target.closest('.unf-mega__toggle');
    if (!boton) return;
    event.preventDefault();
    var abierto = boton.getAttribute('aria-expanded') === 'true';
    boton.setAttribute('aria-expanded', abierto ? 'false' : 'true');
    var li = boton.closest('li');
    if (!li) return;
    var lista = li.querySelector('.unf-mega__sublinks');
    if (lista) lista.hidden = abierto;
  });

  /* ── Escape cierra el mega menu de escritorio ── */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var activo = document.querySelector('.thb-full-menu li.menu-item-has-megamenu:hover .unf-mega, .thb-full-menu li.menu-item-has-megamenu:focus-within .unf-mega');
    if (!activo) return;
    var enlacePadre = activo.closest('li').querySelector(':scope > a');
    if (enlacePadre) {
      enlacePadre.blur();
      enlacePadre.focus();
      event.preventDefault();
    }
  });
})();
